import React, { useContext, useEffect } from "react";
import axios from "axios";
import TranslateContext from "../../context/TranslateContext";
import { languageList } from "../../utils/languageList";
import "./SelectBox.css";

const SelectBox = () => {
  const TranslateCtx = useContext(TranslateContext);
  const { language, enteredText } = TranslateCtx;
  // const [selectedLanguage, setSelectedLanguage] = useState("es-ES");

  const handleChange = (e) => {
    let selectedValue = e.target.value;
    let selectedLanguage = languageList.find(
      (item) => item.id === selectedValue
    ).speech;
    // setSelectedLanguage(selectedLanguage);
    TranslateCtx.setLanguage(selectedLanguage);
  };

  const performTranslation = () => {
    axios
      .get(
        `https://translate.timpetrvalsky.com/translate/?from=${enteredText}&lang=${TranslateCtx.language}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        TranslateCtx.setTransText(response.data.translation);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    performTranslation();
  }, [language]);

  return (
    <div className="test">
      <div className="header-main">
        <form className="select">
          <label>
            <span className="dropdown-title">Choose a Language</span>
            <select onChange={handleChange} className="select">
              {languageList.map((item) => {
                return (
                  <option key={item.id} value={item.id}>
                    {item.lang}
                  </option>
                );
              })}
            </select>
          </label>
        </form>
      </div>
    </div>
  );
};

export default SelectBox;
